import type { SxProps } from '@cast/design-system';

/** Local sx overrides to align DS table with Phase-1 clusters list spec. */
export const clustersTableSx: SxProps = {
  '&.DS-Table-root': {
    boxShadow: 'none',
    borderRadius: 0,
  },
  '& .DS-Table-hScroller': {
    filter: 'none',
  },
  '& .DS-Table-OverlayContainer': {
    boxShadow: 'none',
  },
  '& .DS-Table-HeaderRowWrapper': {
    minHeight: 40,
    height: 40,
  },
  '& .DS-Table-HeaderCell': {
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  '& .DS-Table-BodyRowWrapper': {
    minHeight: 40,
  },
  '& .DS-Table-BodyRow': {
    minHeight: 40,
  },
  '& .DS-Table-BodyCellWrapper': {
    py: 0,
  },
};
